"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UP_ARROW = '▲';
exports.DOWN_ARROW = '▼';
function symbolForDelta(delta) {
    if (delta.absolute === 0) {
        return '';
    }
    return delta.absolute < 0 ? exports.DOWN_ARROW : exports.UP_ARROW;
}
exports.symbolForDelta = symbolForDelta;
//# sourceMappingURL=symbolForDelta.js.map